export default __webpack_public_path__ + "static/media/example.741f0754.png";